import type * as z from 'zod';

import { agreementQueryLinkerSchema } from './agreements-query-linker-schema';

import { companyQueryLinkerSchema } from '../companies/company-query-linker-schema';

export const addendumTableSchema = agreementQueryLinkerSchema.extend({
  client: companyQueryLinkerSchema,
});

export type AddendumTableSchema = z.infer<typeof addendumTableSchema>;

export const agreementTableSchema = addendumTableSchema;
export type AgreementTableSchema = AddendumTableSchema;
